"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var a = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var a__default = /*#__PURE__*/_interopDefaultLegacy(a);

var r=a__default["default"].div`
  border-radius: var(--border-radius-small);
  min-height: 96px;
  box-shadow: var(--elevation-100);
  padding: var(--spacing-x-large);
  background: var(--background-level-1);

  & & {
    box-shadow: none;
    border: 1px solid var(--border-default);
  }
`;r.displayName="Section";var o=r;

exports.a = o;
